import { CaseItem } from '@shared/models/case-item.model';

export class User {
    constructor(
      public firstName: string,
      public familyName: string,
      public nrOfAllowedAdditionalDocs: number,
      public masterId: string,
      public entryId: string,
      public creationTime: string,
      public updateTime: string,
      public currentVersion: number,
      public caseItems: CaseItem[],
    ) {}
  }
